import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable, Subject } from 'rxjs';
import { NotificationMessage } from '../components';
import { CourseDetailsModelV2, QuizQuestionDetailV3 } from '../models';

export type NotificationEventPayloads = CourseDetailsModelV2 | QuizQuestionDetailV3 | string; // CourseDetailsModelV2 | Any others model here
export interface NotificationEvent<T extends NotificationEventPayloads = NotificationEventPayloads> {
  type: string;
  payload?: T;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private messages$ = new BehaviorSubject<NotificationMessage[]>([]);
  constructor() {}

  add(message: NotificationMessage) {
    this.messages$.next(this.validMessages.concat(message));
  }

  remove(messageId: string) {
    this.messages$.next(this.validMessages.filter((m) => m.id !== messageId));
  }

  clear() {
    this.messages$.next([]);
  }

  get messages() {
    return this.messages$.asObservable();
  }

  private get validMessages() {
    return this.messages$.getValue().filter((m) => !m.expiredAt || m.expiredAt > Date.now());
  }

  // New
  private eventSubject = new Subject<NotificationEvent>(); // Single event stream

  events$ = this.eventSubject.asObservable();

  emit<T extends NotificationEventPayloads>(type: string, payload?: T) {
    this.eventSubject.next({ type, payload });
  }

  on<T extends NotificationEventPayloads>(type: string): Observable<NotificationEvent<T>> {
    return this.events$.pipe(filter((event) => event.type === type)) as Observable<NotificationEvent<T>>;
  }
}
